<form [formGroup]="searchForm">
    <input type="text"
           formControlName="search"
           [maxLength]="maxQueryLength"
           [placeholder]="placeholderText"
           (keyup.enter)="searchByEnter()"
           (input)="emitSearchValue()"
           (blur)="performSearch()">
    <i class="icon-search search-icon"></i>

    <button id="clear-search-field"
        appTrackClickButton
        type="button"
        *ngIf="searchForm.get('search').value?.length"
        class="clear-control icon-cross_16px"
        (click)="resetState()"></button>
</form>
